import { render } from "./ContactsPeopleContactInfoEditor.vue?vue&type=template&id=4594db84"
import script from "./ContactsPeopleContactInfoEditor.vue?vue&type=script&lang=js"
export * from "./ContactsPeopleContactInfoEditor.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__